/** Frozen activity row pinned on an activity report (details step pick). */

export type ReportSelectedActivity = {
  sourceId: string,
  type: string,
  message: string,
  date?: string,
  value?: string,
  units?: string,
  valueMode?: 'value' | 'units',
  activityLogType?: string,
};

export const emptyReportSelectedActivity = (): ReportSelectedActivity | null => null;

export const sanitizeReportSelectedActivity = (raw: unknown): ReportSelectedActivity | null => {
  if (!raw || typeof raw !== 'object') return null;
  const row = raw as Record<string, unknown>;
  const sourceId = String(row.sourceId || '').trim();
  if (!sourceId) return null;
  return {
    sourceId,
    type: String(row.type || 'Activity'),
    message: String(row.message || ''),
    date: row.date ? String(row.date) : undefined,
    value: row.value != null ? String(row.value) : undefined,
    units: row.units != null ? String(row.units) : undefined,
    valueMode: row.valueMode === 'units' ? 'units' : 'value',
    activityLogType: row.activityLogType ? String(row.activityLogType) : undefined,
  };
};
